import { 
  CssConfig, 
  ProjectData,
  ActuData,
  TrackType, 
  RadioOptions, 
  NotifbarOptions, 
  CaptchaOptions,
  AlertboxOptions,
  AProposOptions,
  ActuOptions,
  SvgIcons,
  ChatboxOptions
 } from '@js/types'

 import type { 
  APropos,
  Project, 
  Captcha, 
  Radio, 
  Alertbox, 
  Notifbar,
  Actu,
  Chatbox
} from '@js/components'


export const CONSTANTS = {
  css: {} as CssConfig, // loaded from scss file at init (home.ts)
  projectsData: [] as ProjectData[], // loaded from csv file at init (home.ts)

}

/**
 * Component's data.id refers to the css
 */
export const COMPONENTS = {

  radio: {
    object: null as Radio | null,
    data: {
      id: 'radio',
      title: 'radio',
      icons: {} as SvgIcons,
      tracks: [] as TrackType[],
    }
  } as RadioOptions,

  actu: {
    object: null as Actu | null,
    data: {} as ActuData, // data in public/data/actualites.yaml
  } as ActuOptions,

  captcha: {
    object: null as Captcha | null,
    data: {
      id: 'captcha',
      title: 'captcha',
      codes: [], // loaded from public/data/captcha_codes.txt
      img: '' // loaded from assets/motifs/captcha.gif
    }
  } as CaptchaOptions,

  alertbox: {
    object: null as Alertbox | null,
    fadein: 1000
  } as AlertboxOptions,

  notifbar: {
    object: null as Notifbar | null,
    timeout: 30000,
    fadein: 200,
    fadeout: 600,
  } as NotifbarOptions,

  apropos: {
    object: null as APropos | null,
    data: {
      id: 'APropos',
      title: 'À propos',
      statement:'', // loaded from public/data/statement.txt
      email: 'thibault.assiste.par.ordinateur@proton.me',
    },
  } as AProposOptions,

  chatbox: {
    object: null as Chatbox | null,
    data: {},
  } as ChatboxOptions,

  projects: {
    objects: [] as Project[],
    data: [] as ProjectData[],
  },

  thib: {} as HTMLElement

}


// BOT
export const BOT = {}

export const COOKIES = {
  duree: 3, // jours
  captchaCode: ''
}

export var CURSOR: { cursor: any } = {cursor: null}




// tracks: [
//   {
//     name: 'Ocean of Blood',
//     auteur: 'Anthony',
//     path: '@data/sound/tracks/ocean-of-blood_anthony.mp3',
//     adresse: 'https://antoinejosset.com/Music',
//   }, {
//     name: 'Dub psyché',
//     auteur: 'Hugo 2000',
//     path: '@data/sound/tracks/dub-psyche_hugo2000.mp3',
//     adresse: 'https://hugolefur.fr/',
//   }, {
//     name: 'From the air',
//     auteur: 'Laurie Anderson',
//     path: '@data/sound/tracks/from-the-air_Laurie-Anderson.mp3',
//     adresse: 'https://google.fr',
//   }
// ] as TrackType[]